(function(){
  'use strict';
  var NUM='£?\\s*(\\d+(?:\\.\\d{1,2})?)';
  var RE_MAX=new RegExp('\\b(?:under|below|less than|cheaper than|up to|upto|max(?:imum)?|within|no more than|not more than)\\s*'+NUM,'i');
  var RE_MAX2=new RegExp('£\\s*(\\d+(?:\\.\\d{1,2})?)\\s*(?:or less|or under|and under|max|or below)','i');
  var RE_MIN=new RegExp('\\b(?:over|above|more than|from|at least|min(?:imum)?)\\s*'+NUM,'i');
  var RE_BETWEEN=new RegExp('\\bbetween\\s*'+NUM+'\\s*(?:and|-|to)\\s*'+NUM,'i');
  var RE_CHEAP=/\b(cheap(?:est)?|budget|affordable|low[- ]?cost)\b/i;
  var FILLER=/\b(?:i|want|need|looking|for|a|an|the|me|some|show|find|get|any|that|are|is|which|cost|costs|costing|priced|price|prices|only|please|pounds|pound|quid|gbp)\b/gi;
  var SYN=[[/\b(?:jumpers?|sweatshirts?|pullovers?|hoodys?|hoody)\b/gi,'hoodie'],[/\b(?:zip[- ]?up|zipped|zipper|zip-through)\s*(?:hoodie|hoody|jumper)?s?\b/gi,'zip hoodie'],[/\bt[- ]?shirts?\b/gi,'tee'],[/\bposters?\b/gi,'print']];
  var INTENTS=[[/^(?:gift\s*cards?|vouchers?|gift)$/i,'/pages/gift-cards','Gift cards'],[/^(?:delivery|shipping|postage|returns?|refunds?|delivery and returns)$/i,'/pages/delivery-and-returns','Delivery & returns'],[/^(?:points|rewards?|loyalty|club|renegade club)$/i,'/pages/renegade-club-rewards','Renegade Club rewards'],[/^(?:size|sizes|sizing|size guide|size chart|fit)$/i,'/pages/size-fit-guide','Size & fit guide'],[/^(?:black friday|bf|sale|deals?|offers?)$/i,'/pages/black-friday','Black Friday'],[/^(?:refer|referral|refer a friend)$/i,'/pages/refer-a-friend','Refer a friend'],[/^faqs?$/i,'/pages/faq','FAQ']];
  function synonyms(t){SYN.forEach(function(r){t=t.replace(r[0],r[1]);});return t.replace(/\s+/g,' ').trim();}
  function intent(t){for(var i=0;i<INTENTS.length;i++){if(INTENTS[i][0].test(t.trim()))return {url:INTENTS[i][1],label:INTENTS[i][2]};}return null;}
  function clean(s){return s.replace(FILLER,' ').replace(/[£,]/g,' ').replace(/\s+/g,' ').trim();}
  function parse(q){
    var out={terms:q,min:null,max:null,cheap:false,matched:false},m,s=q;
    if((m=s.match(RE_BETWEEN))){out.min=m[1];out.max=m[2];s=s.replace(m[0],' ');}
    else{
      if((m=s.match(RE_MAX))||(m=s.match(RE_MAX2))){out.max=m[1];s=s.replace(m[0],' ');}
      if((m=s.match(RE_MIN))){out.min=m[1];s=s.replace(m[0],' ');}
    }
    if(RE_CHEAP.test(s)){out.cheap=true;s=s.replace(RE_CHEAP,' ');}
    out.priced=out.min!==null||out.max!==null||out.cheap;
    out.terms=synonyms(clean(s));
    out.synonym=out.terms.toLowerCase()!==clean(s).toLowerCase();
    out.matched=out.priced||out.synonym;
    return out;
  }
  function money(n){return '£'+(Math.round(parseFloat(n)*100)/100).toString();}
  function describe(p){
    var bits=[];
    if(p.min!==null&&p.max!==null)bits.push('between '+money(p.min)+' and '+money(p.max));
    else if(p.max!==null)bits.push('under '+money(p.max));
    else if(p.min!==null)bits.push('over '+money(p.min));
    if(p.cheap)bits.push('lowest price first');
    return bits.join(', ');
  }
  window.ORSmartSearch={parse:parse,intent:intent};
  var url;
  try{url=new URL(window.location.href);}catch(e){return;}
  if(url.pathname.replace(/\/+$/,'').slice(-7)!=='/search')return;
  var params=url.searchParams,q=params.get('q')||'';
  var note=document.querySelector('[data-smart-note]');
  function ready(fn){if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',fn);else fn();}
  function show(parts){
    if(!note)return;
    note.innerHTML='';
    parts.forEach(function(x){
      if(x.href){var a=document.createElement('a');a.href=x.href;a.textContent=x.text;note.appendChild(a);}
      else note.appendChild(document.createTextNode(x.text));
    });
    note.hidden=false;
  }
  ready(function(){
    var hasPriceFacet=!!document.querySelector('input[name="filter.v.price.lte"],input[name="filter.v.price.gte"]');
    var smart=params.get('smart');
    if(smart!==null){
      var p=parse(smart),clear=new URL(window.location.href);
      ['filter.v.price.lte','filter.v.price.gte','smart','sort_by','page'].forEach(function(k){clear.searchParams.delete(k);});
      clear.searchParams.set('q',p.terms||smart);
      var bits=describe(p),parts=[{text:'Showing '+(p.terms?'“'+p.terms+'”':'all products')+(bits?' '+bits:'')+(p.synonym?' (you searched “'+smart+'”)':'')+'. '}];
      if(p.priced)parts.push({href:clear.pathname+clear.search,text:'Clear price filter'});
      show(parts);
      return;
    }
    if(!q)return;
    var hit=intent(q);
    if(hit){show([{text:'Looking for '},{href:hit.url,text:hit.label+' →'},{text:'? Product results are below.'}]);}
    if(params.has('filter.v.price.lte')||params.has('filter.v.price.gte'))return;
    var parsed=parse(q);
    if(!parsed.matched)return;
    var usePrice=parsed.priced&&hasPriceFacet;
    if(!usePrice&&!parsed.synonym)return;
    if(!parsed.terms&&!usePrice)return;
    var dest=new URL(window.location.origin+(parsed.terms?url.pathname:'/collections/all'));
    if(parsed.terms){
      dest.searchParams.set('q',parsed.terms);
      dest.searchParams.set('type',params.get('type')||'product');
      dest.searchParams.set('options[prefix]','last');
    }
    if(usePrice){
      if(parsed.max!==null)dest.searchParams.set('filter.v.price.lte',parsed.max);
      if(parsed.min!==null)dest.searchParams.set('filter.v.price.gte',parsed.min);
      if(parsed.cheap||parsed.max!==null)dest.searchParams.set('sort_by',parsed.cheap?'price-ascending':(params.get('sort_by')||'relevance'));
    }
    if(parsed.terms)dest.searchParams.set('smart',q);
    window.location.replace(dest.pathname+dest.search);
  });
})();
